exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".observe-students-container {\n  width: 100%;\n  flex: 1 0 auto;\n}\n.observe-students-container .observe-students {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: center;\n  flex: 0 0 auto;\n  align-items: flex-start;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/ObserveStudents.styl
// module id = 1911
// module chunks = 1